import React from 'react';
import ReactDOM from 'react-dom/client'
import {Provider} from 'react-redux';
import './resources/scss/index.scss'
import reportWebVitals from './utils/reportWebVitals';
import store from './utils/store';
import App from './containers/App';
import {BrowserRouter} from "react-router-dom";

const reactRoot = ReactDOM.createRoot(document.getElementById('root'))
reactRoot.render(
    <Provider store={store}>
        <BrowserRouter>
            <App/>
        </BrowserRouter>
    </Provider>
);

reportWebVitals();
